import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@store/index";
import { logoutUser } from "../../auth/authSlice";

const Forbidden = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logoutUser(navigate));
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      gap={4}
    >
      <Typography variant="h5">
        Forbidden: You do not have permission to access this page.
      </Typography>

      <Box display="flex" gap={2}>
        <Button variant="contained" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button variant="contained" onClick={handleLogout}>
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default Forbidden;
